const styles = theme => ({
  root: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    width: '100%',
  },
  stepper: {
    padding: '8px 0 24px',
    backgroundColor: 'transparent',
  },
  stepBody: {
    minHeight: '280px',
  },
  settingsToggle: {
    padding: '12px 16px',
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #F1F5F9',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#E2E8F0',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
  },
  settingsContent: {
    marginTop: '16px',
    padding: '20px',
    backgroundColor: '#F8FAFC',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
  },
  primaryButton: {
    height: '44px',
    padding: '0 24px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '10px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
  },
  secondaryButton: {
    height: '44px',
    padding: '0 24px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    color: '#475569',
    '&:hover': {
      backgroundColor: '#F1F5F9',
      borderColor: '#CBD5E1',
    },
  },
  linkCard: {
    padding: '16px',
    backgroundColor: '#F8FAFC',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
    textAlign: 'left',
    marginTop: '12px',
    width: '100%',
  },
  linkLabel: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '8px',
    display: 'block',
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    padding: '4px 4px 4px 16px',
    gap: '8px',
  },
  linkUrl: {
    fontSize: '13px',
    color: '#1E293B',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  linkActions: {
    display: 'flex',
    gap: '4px',
  },
  actionIconBtn: {
    padding: '6px',
    color: '#64748B',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#F1F5F9',
      color: '#3B82F6',
    },
  },
  copySuccess: {
    color: '#10B981 !important',
  },
  noticeInfo: {
    padding: '12px 16px',
    borderRadius: '10px',
    backgroundColor: '#EFF6FF',
    border: '1px solid #BFDBFE',
    color: '#1E3A8A',
    textAlign: 'left',
    width: '100%',
    maxWidth: 440,
  },
  noticeError: {
    padding: '12px 16px',
    borderRadius: '10px',
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    color: '#7F1D1D',
    textAlign: 'left',
    width: '100%',
    maxWidth: 440,
  },
})

export default styles
